import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=a7019a16&scoped=true"
import script from "./Hint.vue?vue&type=script&lang=js"
export * from "./Hint.vue?vue&type=script&lang=js"
import style0 from "./Hint.vue?vue&type=style&index=0&id=a7019a16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7019a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7019a16')) {
      api.createRecord('a7019a16', component.options)
    } else {
      api.reload('a7019a16', component.options)
    }
    module.hot.accept("./Hint.vue?vue&type=template&id=a7019a16&scoped=true", function () {
      api.rerender('a7019a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/Hint.vue"
export default component.exports